import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enGb from './locales/en-GB.json';
import nlNl from './locales/nl-NL.json';

export type SupportedLanguage = 'en-GB' | 'nl-NL';

export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = ['en-GB', 'nl-NL'];

/**
 * Synchronously initialise i18next with the bundled `en-GB` and
 * `nl-NL` resources. Bundles are imported as JSON modules so the
 * initial language switch never blocks on a network round-trip.
 *
 * The detected language is overridden later by
 * `PreferencesHydrator` once the user's profile has been fetched.
 */
export function initI18n(): typeof i18n {
  if (!i18n.isInitialized) {
    void i18n.use(initReactI18next).init({
      resources: {
        'en-GB': { translation: enGb },
        'nl-NL': { translation: nlNl },
      },
      lng: 'en-GB',
      fallbackLng: 'en-GB',
      supportedLngs: SUPPORTED_LANGUAGES,
      interpolation: { escapeValue: false },
      returnNull: false,
    });
  }
  return i18n;
}

export { i18n };
export default i18n;
